import { createSlice } from "@reduxjs/toolkit";
import { initialGlobalConfig } from "./config/initialGlobalConfig";

const globalConfigSlice = createSlice({
  name: "globalConfig",
  initialState: { ...initialGlobalConfig },
  reducers: {
    setGlobalConfig: (state, action): any => {
      return {
        ...action.payload,
      };
    },
    resetGlobalConfig: (state: any): any => {
      return {
        ...initialGlobalConfig,
      };
    },
    updateGlobalConfig: (state, action): any => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setGlobalConfig, updateGlobalConfig, resetGlobalConfig } =
  globalConfigSlice.actions;
export default globalConfigSlice.reducer;
